import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';

export interface IHistoryItem {
	year?: string;
	image?: IImage;
	heading?: string;
	text?: string;
}

export interface IHistoryTimelineProps extends IBaseElementProps {
	items?: IHistoryItem[];
}

/**
 * History Timeline
 * @block
 * @requiresHooks
 * @icon images-alt
 */
const HistoryTimeline: React.FC<IHistoryTimelineProps> = ({
	className,
	classNames = [],
	items = [],
}) => {
	if (!Array.isArray(items) || !items.length) {
		return null;
	}

	return (
		<div className={className || cn('history-timeline', ...classNames)}>
			{items.map(({ year, image, heading, text }, index) => (
				<div
					key={index}
					className={
						'history-timeline__item ' +
						(image != null ? '' : 'no-image')
					}
				>
					<div className="history-timeline__item__year">{year}</div>
					{image && (
						<Image
							{...image}
							className="history-timeline__item__image"
						/>
					)}

					<h4 className="history-timeline__item__heading">
						{heading}
					</h4>
					<div className="history-timeline__item__text">{text}</div>
				</div>
			))}
		</div>
	);
};

export default HistoryTimeline;
